import styled from "styled-components";

export const UserSideMenuList = styled.ul`
  width: 100vw;
  height: 100%;
  min-height: calc(100vh - 56px);
  background: ${(props) => props.theme.colors.mainBg};
`;
